<template>
  <v-footer height="auto">
    <v-layout justify-center row wrap>
        <NewsletterForm v-if="showNewsLetter" />
      <v-flex py-3 text-xs-center secondary--text xs12 >
        <div class="pb-2">
          <a class="secondary--text" target="_blank" :href="_getRouteUrl('screeners.archive')">
            {{  $t('footer.menu.archive') }}
          </a>
          <a v-if="companyId == DEFINES.FIREPLACE_AD_COMPANY_ID" class="secondary--text mr-2" :href="_getRouteUrl('user.dashboard')">
            {{  $t('rms.toolbar.consumer.header.menu.dashboard') }}
          </a>

          <a v-if="company.slug !='netfest'" class="secondary--text pl-1" target="_blank" :href="DEFINES.HOMEPAGE_LINK">
            {{  $t("watch.title") }}
          </a>
          <template v-for="(menu, i) in menus">
            <a
              v-if="!menu.title && def_pages[menu.slug]"
              class="secondary--text ml-2"
              :key="i + menu.text"
              :href="_getRouteUrl(menu.link)"
              target="_blank"
            >{{ menu.text }}</a>
            <a
              v-if="menu.title"
              class="secondary--text ml-2"
              :key="i + menu.slug"
              :href="menu.isExternal ? menu.link : _getRouteUrl('company.page',{slug:menu.slug})"
              target="_blank"
            >{{ menu.title }}</a>
          </template>
        </div>
        <!-- If SA enabled ORG branding & there is footer msg -->
        <div v-if="company.show_company_branding && company.custom_properties.powered_by_message">
            {{company.custom_properties.powered_by_message}}
        </div>
        <div v-else>
          &copy;{{ moment().format("YYYY") }} —
          {{ $t("screener.powered_by.text") }}
          <a
            target="_blank"
            href="https://movieseverywhere.net/"
            class="text-decoration-none"
          >
            <strong class="primary--text">Movies Everywhere</strong>
          </a>
          <small class="pl-4">Version: {{ DEFINES.APP_VERSION }}</small>
        </div>
      </v-flex>
    </v-layout>
  </v-footer>
</template>
<script>
import i18n from "@/i18n";
import DEFINES from "@/defines";
import { mapState, mapGetters } from "vuex";
import NewsletterForm from "@/components/NewsletterForm"

export default {
  name: "CompanyFooter",
  components: {
    NewsletterForm
  },
  data: () => ({
    def_pages: {
      about: true,
      terms: true,
      privacy: true
    }
  }),
  mounted() {
    this.getApiData();
  },

  computed: {
    ...mapState({
      list: state => state.page.list,
      company: state => state.company.company
    }),
    ...mapGetters("company", {
      companyId: "getCurrentCompanyId"
    }),
    menus() {
      var default_menus = [
        {
          slug: "about",
          text: i18n.t("page.about"),
          link: "company.about",
        },
        {
          slug: "privacy",
          text: i18n.t("page.privacy"),
          link: "company.privacy",
        },
        {
          slug: "terms",
          text: i18n.t("page.terms"),
          link: "company.terms",
        },
      ];
      return this.list && this.list.length
        ? default_menus.concat(this.list)
        : default_menus;
    },
    showNewsLetter: function(){
      return  this.company
              && this.company.custom_properties.mcApiKey
              && this.company.custom_properties.mcListId;
    }
  },

  watch: {
    companyId() {
      this.getApiData();
    },
    list() {
      this.processData();
    }
  },

  methods: {
    async getApiData() {
      if (!this.companyId) {
        return;
      }
      try {
        var response = await this.$store.dispatch("page/list");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    processData() {
      if (
        this.company &&
        this.company.custom_properties &&
        this.company.custom_properties.hasOwnProperty("def_pages")
      ) {
        this.def_pages = this.company.custom_properties.def_pages;
      }
    },
    _getRouteUrl(routeName, params={}){
      if(!routeName) return;
      const route = this.$router.resolve({ name: routeName, params: params })
      return route.href;
    }
  }
};
</script>
<style>
.text-decoration-none{
  text-decoration: none;
}
</style>
